/** Markdown opens in the reader unless the person asks to edit. */
export const isMarkdown = (name: string) => /\.(md|markdown)$/i.test(name)
